import { FareCardKey, VsEligibility } from "../../_common/read-models/fare-card"
import { FareInfographicBoxStatus } from "../../../../components/FareInfographicBox/FareInfographicBox"
import { VsCodeState } from "../../_common/machines/ecommerce-machine/e-commerce-machine-context"
import { ECommerceState } from "../../_common/machines/ecommerce-machine/e-commerce-machine"

export type VenetianSocietyStatus = "applied" | VsEligibility

export const computeVenetianSocietyStatus = (
    vsEligibility: VsEligibility,
    vsCode: VsCodeState,
): VenetianSocietyStatus => (vsEligibility == "eligible" && vsCode.type == "valid" ? "applied" : vsEligibility)

export const fareInfographicBoxStatus = (fareKey: FareCardKey, state: ECommerceState): FareInfographicBoxStatus => {
    if (state.context.flowVersion.ui.areFareCardsSelectable(state))
        return state.context.selectedFare?.key === fareKey ? "selected" : "unselected"
    return "none"
}
